const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;
const STORAGE_PREFIX = 'utm_';

/** Call once on app init to capture UTM params from the URL into sessionStorage. */
export const captureUtmParams = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    let hasAny = false;

    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value) {
        sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
        hasAny = true;
      }
    }

    // If we got new UTM params, also store the landing page
    if (hasAny) {
      sessionStorage.setItem('utm_landing_page', window.location.pathname);
    }
  } catch {
    // sessionStorage may be unavailable in some browsers
  }
};

/** Returns the currently stored UTM params (or empty values). */
export const getUtmParams = (): {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
} => {
  try {
    return {
      utm_source: sessionStorage.getItem(`${STORAGE_PREFIX}utm_source`) || null,
      utm_medium: sessionStorage.getItem(`${STORAGE_PREFIX}utm_medium`) || null,
      utm_campaign: sessionStorage.getItem(`${STORAGE_PREFIX}utm_campaign`) || null,
    };
  } catch {
    return { utm_source: null, utm_medium: null, utm_campaign: null };
  }
};
